import { select, put } from 'redux-saga/effects';
import { fetch } from '../../../_app/middleware/fetch';
import config from '../../../config';

// ACTIONS

export const SET_STAFF_LIST_DATA = 'SET_STAFF_LIST_DATA';
export const SET_STAFF_LIST_ERRORS = 'SET_STAFF_LIST_ERRORS';
export const SET_UPLOADING_COMPLETE = 'SET_UPLOADING_COMPLETE';
export const SET_UPLOADING = 'SET_UPLOADING';
export const SET_UPLOAD_PERCENTAGE = 'SET_UPLOAD_PERCENTAGE';
export const SET_CSV_DATA = 'SET_CSV_DATA';
export const SET_FILENAME = 'SET_FILENAME';
export const GET_STAFF_CSV = 'GET_STAFF_CSV';
export const SEND_STAFF_LIST = 'SEND_STAFF_LIST';
export const SET_INSTRUCTIONS_VIEWED = 'SET_INSTRUCTIONS_VIEWED';
export const SET_CSV_TEMPLATE_DOWNLOADED = 'SET_CSV_TEMPLATE_DOWNLOADED';
export const SET_SHOW_TABLE = 'SET_SHOW_TABLE';
export const SEND_VALIDATED_STAFF_LIST = 'SEND_VALIDATED_STAFF_LIST';
export const SET_STAFF_LIST_UPLOADED = 'SET_STAFF_LIST_UPLOADED';
export const SET_TAB_VIEW = 'SET_TAB_VIEW';
export const SEND_STAFF_EMAIL = 'SEND_STAFF_EMAIL';
export const TOGGLE_STAFF_SEND_DISABLE = 'TOGGLE_STAFF_SEND_DISABLE';
export const TOGGLE_STAFF_EMAIL_SENT = 'TOGGLE_STAFF_EMAIL_SENT';
export const SET_STAFF_TAB_VIEW = 'SET_STAFF_TAB_VIEW';

// ACTION CREATORS

export function sendStaffEmail() {
  return { type: SEND_STAFF_EMAIL };
}

export function setInstructionsViewed(boolean) {
  return { type: SET_INSTRUCTIONS_VIEWED, payload: boolean };
}

export function setTemplateDownloaded(boolean) {
  return { type: SET_CSV_TEMPLATE_DOWNLOADED, payload: boolean };
}

export function setUploading(boolean) {
  return { type: SET_UPLOADING, payload: boolean };
}

export function setUploadPercentage(value) {
  return { type: SET_UPLOAD_PERCENTAGE, payload: value };
}

export function setUploadComplete(boolean) {
  return { type: SET_UPLOADING_COMPLETE, payload: boolean };
}

export function setFilename(value) {
  return { type: SET_FILENAME, payload: value };
}

export function setUploadCSV(data) {
  return { type: SET_CSV_DATA, payload: data };
}

export function sendCSV() {
  return { type: SEND_STAFF_LIST };
}

export function setShowTable(boolean) {
  return { type: SET_SHOW_TABLE, payload: boolean };
}

export function sendValidatedStaffList() {
  return { type: SEND_VALIDATED_STAFF_LIST };
}

export function toggleStaffSendDisable(boolean) {
  return { type: TOGGLE_STAFF_SEND_DISABLE, payload: boolean };
}

export function toggleStaffEmailSent(boolean) {
  return { type: TOGGLE_STAFF_EMAIL_SENT, payload: boolean };
}

export function setStaffTabView(tabView) {
  return { type: SET_STAFF_TAB_VIEW, payload: tabView };
}
// SAGAS

export const getCSVData = state => state.setupStaff.csvData;
export const getstaffLIstData = state => state.setupStaff.staffListData;
const getRegistrationId = state => state.user.registrationId;
const getNcesDistrictId = state => state.onboarding.ncesDistrictId;
const getNcesSchoolId = state => state.onboarding.ncesSchoolId;

export function* uploadCSV() {
  const file = yield select(getCSVData);
  const singleSchool = yield select(getNcesSchoolId);
  const registrationId = yield select(getRegistrationId);

  yield put({ type: SET_UPLOADING, payload: true });
  yield put({ type: SET_UPLOAD_PERCENTAGE, payload: 0 });

  try {
    if (file) {
      const data = new FormData();
      data.append('file', file);

      if (singleSchool) data.append('singleSchool', true);

      const action = {
        data,
        method: 'post',
        url: `${
          config.REACT_APP_API_BASE_URL
        }/districts/onboarding/${registrationId}/staff-csv`,
      };

      const response = yield fetch(action);
      const { data: res } = response;

      let { validationErrors } = res;
      const { entities, generalErrors } = res;

      // Gross little adaptation layer.
      if (generalErrors.length > 0) {
        validationErrors = [
          { lineNumber: 0, reasons: generalErrors }
        ].concat(validationErrors)
      }

      yield put({ type: SET_STAFF_LIST_DATA, payload: entities });
      if (validationErrors.length === 0) {
        yield put({ type: SET_STAFF_LIST_ERRORS, payload: [] });
      } else {
        yield put({ type: SET_STAFF_LIST_ERRORS, payload: validationErrors });
      }
      yield put({ type: SET_UPLOAD_PERCENTAGE, payload: 100 });
      yield put({ type: SET_UPLOADING_COMPLETE, payload: true });
    } else {
      yield put({ type: SET_UPLOAD_PERCENTAGE, payload: 0 });
    }
  } catch (error) {
    yield put({ type: SET_UPLOAD_PERCENTAGE, payload: 0 });
  }
}

export function* uploadValidatedStaffList() {
  // TODO: Get registration ID from container
  const registrationId = yield select(getRegistrationId);
  const data = yield select(getstaffLIstData);
  try {
    const action = {
      data,
      method: 'post',
      url: `${
        config.REACT_APP_API_BASE_URL
      }/districts/onboarding/${registrationId}/staff-upload`,
    };

    yield fetch(action);
    yield put({ type: SET_STAFF_TAB_VIEW, payload: 2 });
  } catch (error) {
    yield put({ type: SET_STAFF_LIST_UPLOADED, payload: false });
  }
  yield put({ type: SET_STAFF_LIST_UPLOADED, payload: true });
}

export function* postStaffEmail() {
  const registrationId = yield select(getRegistrationId);
  const action = {
    method: 'post',
    url: `${
      config.REACT_APP_API_BASE_URL
    }/districts/onboarding/${registrationId}/send-staff-email`,
  };
  const response = yield fetch(action);
}

// SETUP REDUCER

const initialState = {
  instructionsViewed: false,
  templateDownloaded: false,
  uploading: false,
  csvData: {},
  staffListData: [],
  order: 'desc',
  orderBy: 'name',
  uploadComplete: false,
  uploadPercentage: 50,
  filename: '',
  showTable: false,
  validationResults: [],
  validationResultsUploaded: false,
  staffTabView: 1,
};

export const staffSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INSTRUCTIONS_VIEWED:
      return {
        ...state,
        instructionsViewed: action.payload,
      };
    case SET_CSV_TEMPLATE_DOWNLOADED:
      return {
        ...state,
        templateDownloaded: action.payload,
      };
    case SET_UPLOADING:
      return {
        ...state,
        uploading: action.payload,
      };
    case SET_UPLOAD_PERCENTAGE:
      return {
        ...state,
        uploadPercentage: action.payload,
      };
    case SET_CSV_DATA:
      return {
        ...state,
        csvData: action.payload,
      };
    case SET_STAFF_LIST_DATA:
      return {
        ...state,
        staffListData: action.payload,
      };
    case SET_STAFF_LIST_ERRORS:
      return {
        ...state,
        validationResults: action.payload,
      };
    case SET_FILENAME:
      return {
        ...state,
        filename: action.payload,
      };
    case SET_SHOW_TABLE:
      return {
        ...state,
        showTable: action.payload,
      };
    case SET_UPLOADING_COMPLETE:
      return {
        ...state,
        uploadComplete: action.payload,
      };
    case SET_STAFF_LIST_UPLOADED:
      return {
        ...state,
        validationResultsUploaded: action.payload,
      };

    case TOGGLE_STAFF_SEND_DISABLE:
      return {
        ...state,
        staffSendDisable: action.payload,
      };

    case TOGGLE_STAFF_EMAIL_SENT:
      return {
        ...state,
        staffEmailSent: action.payload,
      };
    case SET_STAFF_TAB_VIEW:
      return {
        ...state,
        staffTabView: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/setup-staff.duck.js